import React, { useState, useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { deposit } from '@ally/data-selectors-afg-accounts'
import { useHostServices } from '../../HostServices'
import { AccountDetailsSkeletonLoader } from '../../components/common/AccountDetailSkeletonLoader'

/* There isn't much actual logic to test here, and setting up
all of the react-router-dom mocks would be more effort than it's worth */

/* istanbul ignore file */

export const CheckingRedirector: React.FC = () => {
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const { hostData } = useHostServices()
  const afgAccountsStatus = hostData.afgAccounts.status.loadState
  const checkingAccounts =
    deposit.nonRetirement
      .getDDA(hostData)
      .filter(account => account.status.toLowerCase() === 'active') || []

  useEffect(() => {
    if (afgAccountsStatus === 'loaded') {
      setLoading(false)
    }
  }, [afgAccountsStatus])

  if (loading) {
    return <AccountDetailsSkeletonLoader />
  }

  // no checking accounts
  if (checkingAccounts.length === 0) {
    return <Redirect to="/dashboard" />
  }

  // done loading -> fetch checking account with highest balance
  const foundAccount = checkingAccounts.reduce((accumulator, account) => {
    if (!accumulator) {
      return account
    }

    const prevHighest = accumulator.balance?.available || 0
    const current = account.balance?.available || 0

    return prevHighest < current ? account : accumulator
  })

  const accountId = foundAccount.id
  const openCoverDraftSettings = location.pathname.includes(
    'coverdraft-settings',
  )

  return (
    <Redirect
      to={{
        pathname: `/account/${accountId}/details`,
        state: {
          openCoverDraftSettings,
        },
      }}
    />
  )
}
